<template>
    <div class="room-wrapper">
        <img :src="room.image" alt="Imagen de la habitación" class="room-main-image">
        <div class="room-info-wrapper">
            <h1 class="room-title">{{room.room_title}}</h1>
            <p class="data"><span>Capacidad: </span>{{ room.capacity }}</p>
            <p class="data price">L. {{ room.price }}</p>
            <p class="data">{{ room.description }}</p>
        </div>
        <button class="add_room_btn">Agregar</button>
    </div>
</template>

<script>
    export default {
        name: "RoomResult",
        props: {
            room: {
                type: Object,
                required: true
            }
        }
    }
</script>

<style scoped>
    .room-wrapper {
        display: flex;
        padding: 25px;
        align-items: center;
        border-bottom: 1px solid #999;
    }
    .room-main-image {
        width: 300px;
    }
    .room-info-wrapper {
        margin-left: 20px;
        display: flex;
        flex-direction: column;
    }
    .room-info-wrapper .room-title {
        font-size: 1.5rem;
    }
    .room-info-wrapper .data {
        font-size: 1.2rem;
        margin: 5px;
    }
    .room-info-wrapper .price {
        color: #4d63bc;
        font-size: 2.5rem;
        font-weight: 500;
    }
    .room-wrapper .add_room_btn {
        padding: 15px;
        background-color: #643229;
        color: #F1DDC4;
        font-size: 1.1rem;
        font-weight: 500;
    }

    @media only screen and (min-width: 320px) and (max-width: 767px) {
        .room-wrapper {
            flex-direction: column;
        }
    }
</style>